/**
 * Servicio de NOWPayments API
 * Gestiona la creación de invoices y redirecciones de pago
 */

const API_KEY = 'WFKW7B7-EV5ME7N-NZZTFRC-FJXSBMJ';
const API_ENDPOINT = 'https://api.nowpayments.io/v1/invoice';

export const createNOWPaymentsInvoice = async () => {
  try {
    const payload = {
      price_amount: 99,
      price_currency: 'USD',
      order_id: 'ACCESO-INTENSIVO-01',
      order_description: 'Acceso al Entrenamiento Intensivo',
      success_url: 'https://mralfonsomarin.com/gracias',
      ipn_callback_url: 'https://mralfonsomarin.com/api/now-ipn'
    };

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`Error creating NOWPayments invoice: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('NOWPayments error:', error);
    throw error;
  }
};

export const initiateNOWPaymentsPayment = async () => {
  try {
    const invoice = await createNOWPaymentsInvoice();
    if (invoice && invoice.invoice_url) {
      // Redirigir a la URL de pago
      window.location.href = invoice.invoice_url;
    } else {
      throw new Error('No invoice URL received from NOWPayments');
    }
  } catch (error) {
    console.error('Failed to initiate NOWPayments payment:', error);
    alert('Hubo un error al procesar el pago. Por favor intenta de nuevo.');
    throw error;
  }
};
